import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { EnrollmentType, EnrollmentTypeStrMap } from "../../../../domain/enums/enrollment-type.enum";
import { FormsModule } from "@angular/forms";
import { MatFormField, MatLabel, MatSuffix } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatIconButton } from "@angular/material/button";
import { MatInput } from "@angular/material/input";
import { MatOption } from "@angular/material/core";
import { MatSelect, MatSelectTrigger } from "@angular/material/select";
import { MatChipsModule } from "@angular/material/chips";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CommonModule } from "@angular/common";
import {
  EnrollmentTypeIndicatorComponent
} from "../../../../common/enrollment-type-indicator/enrollment-type-indicator.component";
import { MatTable, MatTableModule } from "@angular/material/table";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { StatusIndicatorComponent } from "../../../../common/status-indicator/status-indicator.component";
import { RouterLink } from "@angular/router";
import { AccountModel } from "../../../../domain/models/account.model";
import { BreadcrumbService } from "../../../../domain/services/breadcrumb/breadcrumb.service";
import { AccountService } from "../../../../domain/services/account/account.service";
import { SearchListDataSource } from "./search-list-datasource";
import { TaskStatusEnum } from "../../../../domain/enums/task-status.enum";
import { FilterTagContainerComponent } from '../../../../common/filter-tag-container/filter-tag-container.component';
import { Icons } from '../../../../domain/enums/icons-enums';

@Component({
  selector: 'app-customer-search',
  standalone: true,
  imports: [MatTableModule, MatPaginatorModule, MatSortModule, EnrollmentTypeIndicatorComponent,
    StatusIndicatorComponent, FormsModule, MatFormField, MatIcon, MatIconButton, MatInput, MatIconModule,
    MatLabel, MatOption, MatSelect, MatSuffix, CommonModule, MatChipsModule, MatTooltipModule, RouterLink, MatSelectTrigger, FilterTagContainerComponent],
  templateUrl: './customer-search.component.html',
  styleUrl: './customer-search.component.css'
})
export class CustomerSearchComponent implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(FilterTagContainerComponent) filterContainer!: FilterTagContainerComponent
  @ViewChild(MatTable) table!: MatTable<AccountModel>;
  dataSource = new SearchListDataSource([]);
  displayedColumns = ['id', 'entityName', 'type', 'email', 'status'];
  accounts: AccountModel[] = [];
  query = "";
  queryStatus: string = "*";
  queryCustomerType: string = "";
  userTypes = Object.keys(EnrollmentType);
  FILTER_CUSTOMER_TYPE = "queryCustomerType";
  FILTER_STATUS = "queryStatus";
  icons = Icons



  constructor(private readonly breadcrumbService: BreadcrumbService,
    private readonly service: AccountService) {
  }

  removeFilter(event: { value: string, type: string }) {
    switch (event.type) {
      case this.FILTER_STATUS:
        this.queryStatus = "";
        break;
      case this.FILTER_CUSTOMER_TYPE:
        this.queryCustomerType = "";
        break;
    }
    this.onFilter();
  }

  ngAfterViewInit(): void {
    this.service.getAll().subscribe(value => {
      this.accounts = value;
      this.rebuildDataSource(this.applyAllFilters(this.accounts))
    })
  }

  rebuildDataSource(data: AccountModel[]) {
    this.dataSource = new SearchListDataSource(data);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.table.dataSource = this.dataSource;
  }

  onFilter() {
    this.rebuildDataSource(this.applyAllFilters(this.accounts));
  }

  applyAllFilters(data: AccountModel[]) {
    this.paginator.pageIndex = 0; //reset paginator on filter
    return this.applySearchFilter(
      this.applyStatusFilter(
        this.applyCustomerTypeFilter(data)));
  }

  applyCustomerTypeFilter(data: AccountModel[]) {
    if (data && data.length > 0 && this.queryCustomerType
      && this.queryCustomerType.length > 0) {
      this.filterContainer.addFilterTag({ value: this.queryCustomerType, type: this.FILTER_CUSTOMER_TYPE, label: this.queryCustomerType })
      return data.filter(value => value.type === this.queryCustomerType);
    } else {
      this.filterContainer.removeTag({ value: this.queryCustomerType, type: this.FILTER_CUSTOMER_TYPE, label: this.queryCustomerType })
      return data;
    }
  }

  applyStatusFilter(data: AccountModel[]) {
    if (data && data.length > 0 && this.queryStatus
      && this.queryStatus.length > 0 && this.queryStatus !== "*") {
      this.filterContainer.addFilterTag({ value: this.queryStatus, type: this.FILTER_STATUS, label: this.queryStatus, icon: this.queryStatus.toLocaleLowerCase() + '-icon' })
      return data.filter(value => value.status === this.queryStatus);
    } else {
      this.filterContainer.removeTag({ value: this.queryStatus, type: this.FILTER_STATUS, label: this.queryStatus })
      this.queryStatus = '*'
      return data;
    }

  }

  applySearchFilter(data: AccountModel[]) {
    if (data && data.length > 0) {
      if (this.query.length > 2) {
        const q = this.query.toLowerCase();
        return data.filter(value =>
          value.firstName?.toLowerCase().includes(q)
          || value.lastName?.toLowerCase().includes(q)
          || value.printedName?.toLowerCase().includes(q)
          || value.entityName?.toLowerCase().includes(q)
          || value.email?.toLowerCase().includes(q)
          || value.id?.toString().includes(this.query)
          || value.phoneNumber?.includes(this.query));
      }
    }

    return data;
  }

  clearSerch() {
    this.query = '';
    this.onFilter();
  }

  ngOnInit(): void {
    this.breadcrumbService.updateBreadcrumbs([{
      icon: "search",
      url: "/search",
      label: "Search"
    }]);
  }

  removeFilters() {
    this.queryCustomerType = '';
    this.queryStatus = '*';
    this.onFilter();
  }

  areActiveFilters() {
    return (this.queryStatus && this.queryStatus !== '*') ||
      (this.queryCustomerType && this.queryCustomerType !== '*')
  }

  protected readonly Object = Object;
  protected readonly EnrollmentType = EnrollmentType;
  protected readonly EnrollmentTypeStrMap = EnrollmentTypeStrMap;
  protected readonly TaskStatusEnum = TaskStatusEnum;
}
